import { useLogin } from '@/features/auth/hooks/useLogin';
import { tokenStorage } from '@/features/auth/utils/tokenStorage';
import { getEnvConfig } from '@/config/env';

export const useOnboardingAutoLogin = () => {
    const { loginWithEmail } = useLogin();
    const autoLoginEnabled = getEnvConfig().autoLoginOnPasswordSet;

    const ensureLocation = (): Promise<void> => {
        try {
            tokenStorage.getLocation();
            return Promise.resolve();
        } catch {
            // sin ubicación previa
        }

        const fallback = { lat: 0, lng: 0 };
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            tokenStorage.setLocation(fallback);
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            let settled = false;
            const finish = (coords: { lat: number; lng: number }) => {
                if (settled) return;
                settled = true;
                tokenStorage.setLocation(coords);
                resolve();
            };
            navigator.geolocation.getCurrentPosition(
                (pos) => finish({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
                () => finish(fallback),
                { timeout: 5000 }
            );
            setTimeout(() => finish(fallback), 5000);
        });
    };

    const runAutoLogin = async (email?: string, password?: string): Promise<boolean> => {
        if (!autoLoginEnabled || !email || !password) return false;
        try {
            await ensureLocation();
            await loginWithEmail(email, password);
            return true;
        } catch {
            return false;
        }
    };

    return { autoLoginEnabled, runAutoLogin };
};
